/** Canvas toBlob 转换失败时的错误消息 */
export const CANVAS_TO_BLOB_ERROR_MESSAGE = 'Canvas toBlob failed'

/** PNG 格式的 MIME 类型 */
export const BLOB_MIME_TYPE_PNG = 'image/png'
